import { RATING } from "../constants";

const initialState = {
  summary: null,
  ratings: [],
  isLoadingGetRatings: false,
  error: null,
};

const ratingReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RATING.GET_RATINGS:
      return { ...state, isLoadingGetRatings: true };
    case RATING.GET_RATINGS_FAILURE:
      return { ...state, isLoadingGetRatings: false, error: action.payload };
    case RATING.GET_RATINGS_SUCCESS:
      return {
        ...state,
        isLoadingGetRatings: false,
        summary: action.payload.summary,
        ratings: action.payload.ratings,
        error: null,
      };
    default:
      return state;
  }
};

export default ratingReducer;
